import type { Middleware } from "openapi-fetch";

export const TENANT_HEADER_NAME = "X-SG-Tenant-Id";

type TenantIdResolver = () => string | null | undefined;

interface SetTenantHeaderMiddlewareOptions {
    overrideExisting?: boolean;
}

export function setTenantHeaderMiddleware(
    getTenantId: TenantIdResolver,
    { overrideExisting = false }: SetTenantHeaderMiddlewareOptions = {}
): Middleware {
    return {
        onRequest({ request }) {
            if (!overrideExisting && request.headers.has(TENANT_HEADER_NAME)) {
                return request;
            }

            const tenantId = getTenantId();

            if (tenantId) {
                request.headers.set(TENANT_HEADER_NAME, tenantId);
            }

            return request;
        }
    };
}
